import convertMime from '@/lib/convert-mime-type'
import { slugify } from '@/lib/sanitise-strings'
import { LinkProps } from '@/types/types'
import Link from 'next/link'

// TODO: old component had ids `download-1`, `download-2`, etc. Query for posts that link to these?

type DownloadItem = {
  title: string
  type: 'download'
  file: {
    title: string
    url: string
    mime_type: string
  }
}

type LinkItem = {
  title: string
  type: 'link'
  link: LinkProps
}

type DownloadsAndLinksProps = {
  items: (DownloadItem | LinkItem)[]
  anchorIndex?: number
}

export default function DownloadsAndLinks({ items, anchorIndex = 1 }: DownloadsAndLinksProps) {
  if (!items.length) {
    return null
  }

  return (
    <div className="component component--downloads no-list-styles">
      {/* Auto generated anchor element */}
      <div className="anchor" id={`download-${anchorIndex}`}></div>

      <div className="container @container">
        <div className="flex justify-center border-gradient gradient-angle-[to_bottom] @[0px]/single-simple:!border-0 @m-up:border-l @m-up:border-r">
          <div className="w-full @m-up:max-w-[var(--container-s-max-w)]">
            <ul>
              {items.map((item, index) => {
                // Default to download as legacy data may not have type set
                const type = item.type || 'download'

                const downloadItem = type == 'download' ? (item as DownloadItem) : null
                const linkItem = type == 'link' ? (item as LinkItem) : null

                const linkUrl = downloadItem?.file?.url ?? linkItem?.link?.url

                let linkTitle =
                  downloadItem?.title ??
                  (type === 'download' ? downloadItem?.file?.title : linkItem?.link?.title)
                if (!linkTitle || linkTitle == '') {
                  linkTitle =
                    type === 'download' ? downloadItem?.file?.title : linkItem?.link?.title
                }

                let linkTarget = ''

                if (downloadItem) {
                  linkTarget = '_blank'
                } else {
                  linkTarget = linkItem?.link?.target ?? ''
                }

                const itemAppend = downloadItem ? (
                  <span className="rounded-lg bg-grey-100 px-s py-xxxs text-[length:--p-xs-size] uppercase theme--primary-50:bg-white">
                    {downloadItem.file.mime_type ? convertMime(downloadItem.file.mime_type) : null}
                  </span>
                ) : (
                  <span className="flex gap-xxs rounded-lg bg-grey-100 px-s py-xxxs text-[length:--p-xs-size] uppercase theme--primary-50:bg-white">
                    Link
                    {linkTarget == '_blank' ? (
                      <svg aria-hidden="true" className="aspect-square w-[12px]">
                        <use
                          href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-external-link`}></use>
                      </svg>
                    ) : null}
                  </span>
                )

                return (
                  <li
                    id={`${type}-${slugify(linkTitle)}`}
                    className="border-b border-gradient py-xxs text-fg-title first:border-t"
                    key={index}>
                    <Link
                      href={linkUrl}
                      className="mb-0 flex items-center justify-between py-xxs hover:text-link"
                      target={linkTarget}>
                      <span>{linkTitle}&nbsp;&gt;</span>

                      {itemAppend}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )

  return null
}
